import React from 'react';
import {MENUS} from '../../../../../../utils/query_utils';
import DatasetAttributeInput from '../dataset_attribute_input';
import DatasetAttributeComponent from '../dataset_attribute';

export default class MeasureAttribute extends DatasetAttributeComponent {
    aggregationInput = null;
    combinedInput = null;

    componentDidUpdate(...args) {
        super.componentDidUpdate(...args);
        if (this.state.focusNextInput) {
            this.aggregationInput.focusInput();
        }
    }

    canRemove() {
        return this.props.attribute.column;
    }

    focusColumnInput() {
        this.columnInput.focusInput();
    }

    renderAttribute() {
        const {attribute} = this.props;
        return (
            <>
                {!!attribute.column && (
                    <DatasetAttributeInput
                        attribute={attribute}
                        propName="aggregation"
                        valueProp="label"
                        placeholder="total"
                        menu={MENUS.AGGREGATION}
                        ref={(el) => { this.aggregationInput = el; }}
                    />
                )}
                <DatasetAttributeInput
                    attribute={attribute}
                    propName="column"
                    valueProp="fullName"
                    placeholder="Search for a column"
                    menu={MENUS.COLUMN}
                    ref={(el) => { this.columnInput = el; }}
                />
            </>
        );
    }
}
